import icon from 'vue-svgicon'
icon.register({
  'jifei': {
    width: 1024,
    height: 1024,
    viewBox: '0 0 1024 1024',
    data: '<path d="M97.61 106.49h819.2v68.27H97.61z m750.93 68.27h68.26v750.93h-68.25zM97.61 857.43h819.2v68.26H97.61z m0-136.54h68.27v136.54H97.61z m0-546.13h68.27v136.53H97.61z m0 204.8h136.54v68.27H97.61z m0 204.8h136.54v68.27H97.61z m0-68.26h136.54v68.26H97.61z m0 0M654.37 306.77H591l-38.77 71.43q-29.83 55.85-36.49 74.24h-1.24Q499 417.3 439.34 306.77h-67.61l92 158.05H356.82v49.5h125.32v68.21H356.82v50.13h125.32V732h62.19v-99.34h120.88v-50.13H544.33v-68.21h120.88v-49.5H561.46z" p-id="10363"></path>'
  }
})
